export default "__VITE_ASSET__BKnoMMiz__"